export const gapiConfig = {
  client_id: process.env.VUE_APP_GAPI_CLIENT_ID as string,
  scope:
    'https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile',
  ux_mode: 'popup' as const,
  access_type: 'offline' as const,
  callback: (() => null) as any,
  prompt: 'adfsf'
};
